<button
  class="btn btn-warning btn-ico"
  [ngbTooltip]="'REMINDER_VIEW_BUTTON.GO_TO_TARGET' | translate"
  container="body"
  (click)="preview()"
>
  <i class="fal fa-external-link"></i>
</button>
